<template>
  <div class="o-button-group flex">
    <slot />
  </div>
</template>

<script lang="ts">
export default { name: 'OButtonGroup' }
</script>

<script setup lang="ts">
</script>
